import Form from "../../ui/Form";
import VehicleInfoField from "./VehicleInfoField";
import DateField from "./DateField";
import { deliveryDate, printDate } from "../../utils/date.utils";
import {
  useCreateCustomerAttachmentMutation,
  useUpdateCustomerAttachmentMutation
} from "../../utils/customerAttachment.utils";
import { useNavigate } from "react-router-dom";
import AssignedPersonField from "./AssignedPersonField";
import VehicleShowroomWorksField from "./VehicleShowroomWorksField";

export default function VehicleShowroomWorksForm({
  title,
  defaultValues,
  onBack,
  existShowroomWorks,
  redirectTo
}) {
  const navigate = useNavigate();

  const id = defaultValues?.id ?? null;

  let fields = [
    {
      name: "dateField",
      type: "custom",
      customComponent: DateField,
      col: { md: 12 }
    },
    {
      name: "VehicleInfoField",
      type: "custom",
      customComponent: VehicleInfoField,
      col: { md: 12 },
      others: { defaultValues }
    },
    {
      name: "AssignedPersonField",
      type: "custom",
      customComponent: AssignedPersonField,
      col: { md: 12 }
    },
    {
      name: "VehicleShowroomWorksField",
      type: "custom",
      customComponent: VehicleShowroomWorksField,
      col: { md: 12 },
      others: { defaultValues }
    }
  ];

  // create attachement mutation
  const { loading, createCustomerAttachment } = useCreateCustomerAttachmentMutation([
    "createCustomerAttachment"
  ]);

  const { loading: updating, updateCustomerAttachment } = useUpdateCustomerAttachmentMutation([
    "updateCustomerAttachment"
  ]);

  // after create or update the page will redirect to money receipt list or customer money receipt list
  function handleRedirect() {
    if (redirectTo) {
      navigate(redirectTo);
    }
  }

  const onSubmit = async (values) => {
    let { works } = values;

    // filter only have value
    works = values?.works?.filter((item) => item);

    const showroomWorkDate = printDate(values.showroomWorkDate);
    const po_collector_id = values?.assigned_person?.name?.value ?? "";
    const assigned_date = deliveryDate(values?.assigned_person?.assigned_date);
    const deadline = deliveryDate(values?.assigned_person?.deadline);

    const assigned_person = {
      ...values?.assigned_person,
      assigned_date,
      deadline
    };

    const formattedData = {
      ...values,
      assigned_person,
      works,
      showroomWorkDate
    };

    const strigifyData = JSON.stringify(formattedData);

    let createData = {
      type_id: 4, // showroom works
      attachment: strigifyData,
      po_collector_id // showroom worker assigned person
    };

    // add vehicle id
    createData.stock_list_ids = values?.car?.stock_list_id ? [values?.car?.stock_list_id] : [];

    // update
    if (!!id) {
      const afterUpdated = await updateCustomerAttachment({ id, ...createData });

      if (afterUpdated?.status === 200) {
        handleRedirect();
      }
      return;
    }

    // create
    const afterCreated = await createCustomerAttachment({ ...createData });

    if (afterCreated?.status === 201) {
      handleRedirect();
    }
  };

  const isLoading = loading || updating;

  return (
    <Form
      fields={fields}
      onSubmit={onSubmit}
      defaultValues={defaultValues}
      submitbtnText={isLoading ? `${!!id ? "Editing..." : "Adding...."}` : title}
      loading={typeof isLoading === "boolean" ? isLoading : undefined}
      closebtnText={"Back"}
      onClose={onBack}
    />
  );
}
